<template>
  <div class="container box">
    <div class="columns is-multiline">
      <div class="column is-12">
        <div class="is-flex is-justify-content-space-between is-align-items-center">
          <h1 class="title">Mi perfil</h1>
        </div>
      </div>
      <div class="column is-12">
        <b-tabs expanded>
          <b-tab-item label="Perfil">
            <form id="FormularioCrud" @submit.prevent="sendForm">
              <div class="columns is-multiline">
                <div class="column is-6">
                  <b-field label="Número de socio">
                    <b-input v-model="form.socio" required disabled type="text"></b-input>
                  </b-field>

                  <b-field label="RFC">
                    <b-input v-model="form.rfc" required disabled type="text"></b-input>
                  </b-field>

                  <b-field label="Empresa">
                    <b-input v-model="form.company" required disabled type="text"></b-input>
                  </b-field>

                  <b-field label="Paquete">
                    <b-input v-model="form.package" required disabled type="text"></b-input>
                  </b-field>

                  <b-field label="Vigencia">
                    <b-input v-model="form.validity" required disabled type="text"></b-input>
                  </b-field>

                  <b-field label="Circulo">
                    <b-input v-model="form.circle" required disabled type="text"></b-input>
                  </b-field>
                </div>
                <div class="column is-6">
                  <b-field label="Nombre" label-position="horizontal">
                    <b-input v-model="form.name" disabled type="text"></b-input>
                  </b-field>

                  <b-field label="Apellido">
                    <b-input v-model="form.lastName" required disabled type="text"></b-input>
                  </b-field>

                  <b-field label="Teléfono">
                    <b-input v-model="form.phone" required disabled type="text"></b-input>
                  </b-field>

                  <b-field label="Correo electrónico">
                    <b-input v-model="form.email" required disabled type="email"></b-input>
                  </b-field>

                  <b-field label="Contraseña">
                    <b-input v-model="form.password" type="password"></b-input>
                  </b-field>

                  <b-field label="Privacidad">
                    <div class="is-flex is-flex-direction-column" style="gap: 0.5rem">
                      <b-switch v-model="form.showEmail">Mostrar mi correo electrónico</b-switch>
                      <b-switch v-model="form.showRfc">Mostrar mi RFC</b-switch>
                    </div>
                  </b-field>
                </div>
                <div class="column is-12">
                  <div class="notification is-primary has-text-centered">
                    <p>
                      Cualquier cambio deberá ser solicitado a <br />
                      <a href="mailto:reddenegocios@camaradecomerciogdl.mx">
                        <span class="has-text-weight-bold">reddenegocios@camaradecomerciogdl.mx</span></a
                      >
                    </p>
                  </div>
                </div>
              </div>

              <b-button class="is-success" type="submit" native-type="submit" label="Guardar" expanded></b-button>
            </form>
          </b-tab-item>

          <b-tab-item label="Reuniones">
            <div class="mb-4">
              <b-notification v-if="meetingsSummary" :type="meetingsSummary.blocked ? 'is-danger' : 'is-info'" :closable="false">
                Faltas no justificadas: <strong>{{ meetingsSummary.unjustified_absences }}</strong> / {{ meetingsSummary.threshold }}
                <span v-if="meetingsSummary.blocked"> — Acceso restringido.</span>
              </b-notification>
            </div>

            <b-table :data="meetings" :striped="true" :hoverable="true" :loading="loadingMeetings">
              <b-table-column field="fecha_reunion" label="Fecha" width="160" v-slot="props">
                {{ (props.row.fecha_reunion || '').substr(0, 10) }}
              </b-table-column>
              <b-table-column field="titulo" label="Reunión" v-slot="props">
                <div class="has-text-weight-semibold">{{ props.row.titulo }}</div>
                <div class="has-text-grey is-size-7">{{ props.row.lugar }}</div>
              </b-table-column>
              <b-table-column field="estatus" label="Asistencia" width="180" v-slot="props">
                {{ props.row.estatus }}
              </b-table-column>
            </b-table>
          </b-tab-item>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Swal from 'sweetalert2';
import axiosInstance from '@/api/axiosInstance';

export default {
  data() {
    return {
      form: {},
      meetings: [],
      meetingsSummary: null,
      loadingMeetings: false,
      initialFormState: {
        socio: '',
        rfc: '',
        company: '',
        name: '',
        lastName: '',
        phone: '',
        email: '',
        package: '',
        validity: '',
        circle: '',
        password: '',
        showEmail: true,
        showRfc: true,
      },
    };
  },
  computed: {
    ...mapState({
      partner: (state) => state.auth.partner,
    }),
  },
  async mounted() {
    window.scrollTo(0, 0);
    await this.loadFormData();
    await this.loadMeetings();
  },
  methods: {
    ...mapActions({
      getPartner: 'auth/get',
      submitForm: 'auth/save',
    }),
    async loadFormData() {
      await this.getPartner();

      if (this.partner && Object.keys(this.partner).length) {
        const { nombre, apellido, empresa, telefono, email, socio, rfc, paquete, vigencia, circulo, mostrar_email, mostrar_rfc } = this.partner;

        this.form = {
          name: nombre || this.initialFormState.name,
          lastName: apellido || this.initialFormState.lastName,
          company: empresa || this.initialFormState.company,
          email: email || this.initialFormState.email,
          phone: telefono || this.initialFormState.phone,
          socio: socio || this.initialFormState.socio,
          rfc: rfc || this.initialFormState.rfc,
          package: paquete || this.initialFormState.package,
          validity: vigencia || this.initialFormState.validity,
          circle: circulo || this.initialFormState.circle,
          password: '',
          showEmail: Boolean(Number(mostrar_email ?? 1)),
          showRfc: Boolean(Number(mostrar_rfc ?? 1)),
        };
      } else {
        this.form = { ...this.initialFormState };
      }
    },
    async sendForm() {
      const { showEmail, showRfc, ...rest } = this.form;

      const payload = {
        ...rest,
        mostrar_email: showEmail ? 1 : 0,
        mostrar_rfc: showRfc ? 1 : 0,
      };

      const response = await this.submitForm(payload);

      Swal.fire({
        icon: response.status ? 'info' : 'error',
        title: response.msg,
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: true,
      });
    },
    async loadMeetings() {
      this.loadingMeetings = true;
      try {
        const response = await axiosInstance.post('/socios/meetings', {});
        const payload = response?.data?.data?.meetings || null;
        this.meetings = payload?.list || [];
        this.meetingsSummary = payload?.summary || null;
      } catch (e) {
        this.meetings = [];
        this.meetingsSummary = null;
      } finally {
        this.loadingMeetings = false;
      }
    },
  },
};
</script>

<style scoped>
.form-horizontal {
  max-width: 600px;
  margin: auto;
}
</style>
